import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { MustMatch } from 'src/app/shared/directives/confirmed.validator.directive';
import { OTPService } from 'src/app/core/service/otpservice/otpService';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.css'],
})
export class VerifyOtpComponent implements OnInit {
  otpForm: FormGroup;
  showPassword: boolean;
  passregex = '(?=.*)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%?=*&]).{8,}';
  hide: boolean;
  submitted = false;
  sendData: any;

  constructor(
    private fb: FormBuilder,
    private otpService: OTPService,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.getUserId();
    this.formInit();
  }
  formInit(): void {
    this.otpForm = this.fb.group(
      {
        otp: ['', [Validators.required]],
        userId: [this.sendData],
        password: [
          '',
          [Validators.required, Validators.pattern(this.passregex)],
        ],
        confirmPassword: ['', [Validators.required]],
      },
      {
        validator: MustMatch('password', 'confirmPassword'),
      }
    );
  }
  get f() {
    return this.otpForm.controls;
  }
  // Login Method
  onVerify(): void {
    this.submitted = true;
    if (this.otpForm.invalid) {
      return;
    }
    this.otpService.verifyOtp(this.otpForm.value).subscribe(
      (res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message,
        });
        setTimeout(() => {
          this.router.navigateByUrl('/login');
        }, 3000);
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.message,
        });
      }
    );
  }

  toggleFieldTextType() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordType() {
    this.hide = !this.hide;
  }

  getUserId() {
    var stringArr = sessionStorage.getItem('ui');
    var fin = JSON.parse(stringArr);
    this.sendData = fin;
  }
}
